import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { history, fetchWrapper } from "../_helpers";
import { getStoredValue, removeStoredValue, setStoredValue } from "../_helpers/storagehelper";
// import { fetchWrapper } from "../_helpers/fetch-wrapper";

// create slice

const name = "auth";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
// const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports

export const authActions = { ...slice.actions, ...extraActions };
export const authReducer = slice.reducer;

// implementation

function createInitialState() {
  const Inmate_Setting_Access = JSON.parse(process.env.REACT_APP_INMATE_SETTING);
  const UserData = getStoredValue("user")
  return {
    // initialize state from local storage to enable user to stay logged in
    maintenanceText: [{}],
    downloadResponse: {},
    user: getStoredValue("user"),
    isLoggedIn: getStoredValue("isLoggedIn"),
    error: null,
    managementUserAccessPermission: [],
    AllmanagementUserAccessPermission: [],
    userAccessibleMenuInfo: [],
    menu_list: getStoredValue("menu_list"),
    commonFacilityCode: getStoredValue("commonFacilityCode"),
    isSignalRData: '',
    connectionData: '',
    isDisabledInmate: Inmate_Setting_Access.includes(UserData?.UserRoleID) ? false : true,
    IP: ""
  };
}

function createReducers() {
  return {
    logout,
    updateCommonFacilityCode,
    updateMenuList,
    removeCommonFaciityCode,
    updateUser,
    updateSignalRData,
    updateconnectionData,
    updateisDisabledInmate
  };

  function updateisDisabledInmate(state, action) {
    state.isDisabledInmate = action.payload && action.payload;
  }

  function logout(state, action) {
    state.user = {};
    state.menu_list = [];
    state.commonFacilityCode = "";
    state.isLoggedIn = false;

    const storeduser = getStoredValue("user");
    removeStoredValue("menu_list");
    removeStoredValue("filter_menu_list");
    removeStoredValue("user");
    removeStoredValue("facilityDropDown");
    removeStoredValue("commonFacilityCode");

    removeStoredValue("appSidebarMinify");
    sessionStorage.clear();
    state.AllmanagementUserAccessPermission = [];

    var oldsignalRId = getStoredValue(`signalRId_${storeduser?.ManagementUserID}`);
    if (oldsignalRId && state?.connectionData?._connectionState == "Connected") {
      state?.connectionData.invoke("RemoveUser", oldsignalRId.toString())
    }
    removeStoredValue(`signalRId_${storeduser?.ManagementUserID}`);
    history.navigate("/facilityuser");
  }

  function updateSignalRData(state, action) {
    state.isSignalRData = action.payload && action.payload;
  }

  function updateconnectionData(state, action) {
    state.connectionData = action.payload && action.payload;
  }

  function updateCommonFacilityCode(state, action) {
    state.commonFacilityCode = parseInt(action?.payload, 10);
    setStoredValue("commonFacilityCode", action.payload);
  }
  function updateMenuList(state, action) {
    if (Array.isArray(action?.payload)) {
      state.menu_list = action?.payload;
      setStoredValue("menu_list", action?.payload);
    }
  }
  function removeCommonFaciityCode(state) {
    state.commonFacilityCode = 0;
  }
  function updateUser(state, action) {
    state.user = action.payload;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser/User`;
  const maintanancebaseUrl = `${process.env.REACT_APP_API_URL}/LoginUser`;
  const commonUrl = `${process.env.REACT_APP_API_URL}`;

  return {
    login: login(),
    LoadApplicationMaintence: LoadApplicationMaintence(),
    GetManagementUserAccessPermission: GetManagementUserAccessPermission(),
    GetAllManagementUserAccessPermission: GetAllManagementUserAccessPermission(),
    GetUserAccessibleMenuInfo: GetUserAccessibleMenuInfo(),
    ManagementUserActivityLog: ManagementUserActivityLog(),
    GetIPAddress: GetIPAddress()
  };

  function GetIPAddress() {
    return createAsyncThunk(
      `${name}/GetIPAddress`,
      async () =>
        await fetchWrapper.get(`${commonUrl}/Common/GetIPAddress`)
    );
  }

  function login() {
    return createAsyncThunk(
      `${name}/ValidateLogin`,
      async (loginForm) =>
        await fetchWrapper.post(`${baseUrl}/ValidateLogin`, loginForm)
    );
  }

  function LoadApplicationMaintence() {
    return createAsyncThunk(`${name}/LoadApplicationMaintence`, async () => {
      return await fetchWrapper.get(
        `${maintanancebaseUrl}/LoadApplicationMaintence`
      );
    });
  }

  function GetAllManagementUserAccessPermission() {
    return createAsyncThunk(
      `${name}/GetAllManagementUserAccessPermission`,
      async (ManagementUser) => {
        return await fetchWrapper.get(
          `${baseUrl}/GetManagementUserAccessPermission?ManagementUserID=${ManagementUser.ManagementUserID}&ManagementMenuID=${ManagementUser.ManagementMenuID}`
        );
      }
    );
  }

  function GetManagementUserAccessPermission() {
    return createAsyncThunk(
      `${name}/GetManagementUserAccessPermission`,
      async (ManagementUser) => {
        return await fetchWrapper.get(
          `${baseUrl}/GetManagementUserAccessPermission?ManagementUserID=${ManagementUser.ManagementUserID}&ManagementMenuID=${ManagementUser.ManagementMenuID}`
        );
      }
    );
  }

  function GetUserAccessibleMenuInfo() {
    return createAsyncThunk(
      `${name}/GetUserAccessibleMenuInfo`,
      async (ManagementUserID) => {
        return await fetchWrapper.get(
          `${baseUrl}/GetUserAccesibleMenuInfo?ManagementUserID=${ManagementUserID}`
        );
      }
    );
  }

  function ManagementUserActivityLog() {
    return createAsyncThunk(
      `${name}/ManagementUserActivityLog`,
      async (ActivityLogs) => {
        return await fetchWrapper.post(
          `${process.env.REACT_APP_API_URL}/Common/ManagementUserActivityLog`,
          ActivityLogs
        );
      }
    );
  }
}

function createExtraReducers(builder) {
  builder
    .addCase(extraActions.login.pending, (state) => {
      state.error = null;
    })
    .addCase(extraActions.login.fulfilled, (state, action) => {
      const user = action.payload;
      // if (user?.IsLoginValid === 1) {
      state.commonFacilityCode = user?.FacilityID;
      setStoredValue("commonFacilityCode", user?.FacilityID);
      setStoredValue(
        "menu_list",
        user?.ManagementUserMenu
      );
      state.menu_list = user?.ManagementUserMenu;
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      setStoredValue("user", user);
      setStoredValue("isLoggedIn", true);
      state.user = user;
      state.isLoggedIn = true;
      if (user?.IsLoginValid == 1) {
        window.location.reload();
      }


    })
    .addCase(extraActions.login.rejected, (state, action) => {
      state.error = action.error;
    })

    .addCase(extraActions.LoadApplicationMaintence.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadApplicationMaintence.fulfilled,
      (state, action) => {
        state.loading = false;
        state.maintenanceText = action.payload;
      }
    )
    .addCase(
      extraActions.LoadApplicationMaintence.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    .addCase(
      extraActions.GetManagementUserAccessPermission.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetManagementUserAccessPermission.fulfilled,
      (state, action) => {
        state.loading = false;
        state.managementUserAccessPermission = action.payload;
      }
    )
    .addCase(
      extraActions.GetManagementUserAccessPermission.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    .addCase(
      extraActions.GetAllManagementUserAccessPermission.pending,
      (state) => {
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetAllManagementUserAccessPermission.fulfilled,
      (state, action) => {
        state.loading = false;
        state.AllmanagementUserAccessPermission = action.payload;
      }
    )
    .addCase(
      extraActions.GetAllManagementUserAccessPermission.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )


    .addCase(extraActions.GetUserAccessibleMenuInfo.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.GetUserAccessibleMenuInfo.fulfilled,
      (state, action) => {
        state.loading = false;
        state.userAccessibleMenuInfo = action.payload;
      }
    )
    .addCase(
      extraActions.GetUserAccessibleMenuInfo.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    .addCase(extraActions.ManagementUserActivityLog.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.ManagementUserActivityLog.fulfilled,
      (state, action) => {
        state.loading = false;
      }
    )
    .addCase(
      extraActions.ManagementUserActivityLog.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    .addCase(extraActions.GetIPAddress.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.GetIPAddress.fulfilled,
      (state, action) => {
        state.IP = action.payload;
        if (action.payload?.IpAddress) {
          setStoredValue("cachedIP", action.payload?.IpAddress);
        }
      }
    )
    .addCase(
      extraActions.GetIPAddress.rejected,
      (state, action) => {
        state.error = action.error;
      }
    );
}
